export interface User {
    client_production_timezone: string;
    client_production_uuid: string;
    client_sandbox_timezone: string;
    production_access: boolean;
    sandbox_access: boolean;
    client_sandbox_uuid: string;
    client_sandbox_name: string;
    client_production_name: string;
    email: string;
    environment: "SANDBOX" | "PRODUCTION";
    role: RolesEnum;
    language: "ES" | "EN" | "PT";
    password_expiration_date: string;
    username: string;
    uuid: string;
}
export interface RoleType {
    id: number;
    name: string;
}
export enum RolesEnum {
    god = "god",
    manager = "manager",
    user = "user",
    viewer = "viewer",
    moto = "moto",
    manualPayment = "manual payment",
    batch = "batch",
    payments = "payments",
    noReports = "no reports",
}
export interface UserDetailsProps {
    uuid: string;
    open: boolean;
    onClose: () => void;
    roles: RoleType[] | undefined;
}
export interface UserType {
    uuid: string;
    client_production: string;
    client_sandbox: string;
    created: string;
    status: string;
    access_data: UserAccessDataType | null;
    profile: UserProfileType | null;
}

export interface UserAccessDataType {
    username: string;
    email: string;
    language: string;
    group_id: number;
}

export interface UserProfileType {
    firstname: string;
    lastname: string;
    address: string;
    city: string;
    zip_code: string;
    country: string;
    phone: string;
}
